import type { RoomInfoResponse, SessionResponse } from "@numbet/protocol";
import { consentHeaders } from "./consent.ts";

export class ApiError extends Error {
  readonly code: string;
  readonly status: number;

  constructor(code: string, status: number) {
    super(code);
    this.code = code;
    this.status = status;
  }
}

export async function api<T>(method: string, path: string, body?: unknown): Promise<T> {
  let res: Response;
  try {
    res = await fetch(path, {
      method,
      credentials: "same-origin",
      headers: { ...consentHeaders(), ...(body === undefined ? {} : { "content-type": "application/json" }) },
      body: body === undefined ? null : JSON.stringify(body),
    });
  } catch {
    throw new ApiError("network", 0);
  }
  const text = await res.text();
  const data = text ? (JSON.parse(text) as unknown) : null;
  if (!res.ok) {
    const code = (data as { error?: string } | null)?.error ?? "unknown";
    throw new ApiError(code, res.status);
  }
  return data as T;
}

export const createRoom = (name: string, avatar: string) => api<SessionResponse>("POST", "/api/rooms", { name, avatar });
export const joinRoom = (code: string, name: string, avatar: string) =>
  api<SessionResponse>("POST", `/api/rooms/${code}/players`, { name, avatar });
export const roomInfo = (code: string) => api<RoomInfoResponse>("GET", `/api/rooms/${code}`);
